import React from 'react'
import { useParams } from 'react-router-dom';
import { DescriptionTargetInfo, ItemCardTargetInfo, LogoImageForCardInfo, MainTargetInfo, NumberCalculatorsTargetInfo, NumberGridTargetInfo, SubTitleTargetInfo, ValueTargetInfo } from '../../../../../components/card/MainTargetInfo';
import { JoinStrings } from '../../../../../utils/dataValidations'
import { formatDateWithTime } from '../../../../../utils/dateFormat';
import NoteImage from '../../../../../assets/note.png';
import { useSelector } from 'react-redux';
import { badgeStaticFormatCssStyle } from '../../../../../utils/styleFormat';

const CardInfo = ({ data, setData }) => {
    const params = useParams()
    const reloadSubTable = useSelector(state => state.login.reloadSubTable)
    return (
        <MainTargetInfo
            extraClassName='grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:md:grid-cols-4 gap-1'
            urlApi={`/cuaderno/${params.cuaderno_id}`}
            setData={setData}
            dataRef={[params.cuaderno_id, reloadSubTable]}
        >
            <ItemCardTargetInfo
                // logoLabel={<LogoLabelTargetInfo logo={<NoteIconSvg />} />}
                logo={<LogoImageForCardInfo logo={NoteImage} />}
                aditionalClassName='col-span-2'
            >
                <div className='flex flex-col sm:flex-row gap-2'>
                <SubTitleTargetInfo label='' data={'CUADERNO ' + (data?.codigo ?? '')} />
                    <div className='flex'>
                        {
                            data?.abierto ?
                                <div className={`flex gap-1 items-center font-semibold text-xs mr-2 px-2 py-0.5 rounded-full`} style={badgeStaticFormatCssStyle('abierto')}><span>abierto</span></div>
                                :
                                <div className={`flex gap-1 items-center font-semibold text-xs mr-2 px-2 py-0.5 rounded-full`} style={badgeStaticFormatCssStyle('cerrado')}><span>cerrado</span></div>
                        }
                    </div>
                </div>
                {/* <TitleTargetInfo label={''} data={} /> */}
                {
                    data?.user_id &&
                    <DescriptionTargetInfo label='Propietario:' data={JoinStrings([data.nombres, data.apellido_paterno, data.apellido_materno], ' ')} />
                }
                <DescriptionTargetInfo label='Apertura:' data={formatDateWithTime(data?.fecha_apertura)} />
                <DescriptionTargetInfo label='Cierre:' data={formatDateWithTime(data?.fecha_cierre)} />
                {/* {
                    data?.abierto ?
                        <DescriptionTargetInfo label='Estado de apertura:' data='Abierto' />
                        :
                        <ValueTargetInfo label='Estado de apertura:' data='Cerrado' icon={true} />
                } */}
                {
                    data?.revisado ?
                        <ValueTargetInfo label='Revisión:' data='Revisado' icon={true} />
                        :
                        <DescriptionTargetInfo label='Revisión:' data='Pendiente de revisión' />
                }
            </ItemCardTargetInfo>
            {/* <SubTitleTargetInfo label={null} data={'Detalles'} /> */}
            <NumberCalculatorsTargetInfo>
                <NumberGridTargetInfo label='Ventas Bs.' data={data?.venta_total} />
                <NumberGridTargetInfo label='Deudas Bs.' data={data?.deuda_total} />
                <NumberGridTargetInfo label='Tranferencias Bs.' data={data?.transferencia_total} />
                <NumberGridTargetInfo label='Cobros Bs.' data={data?.cobros_total} />
                <NumberGridTargetInfo label='Gastos Bs.' data={data?.gastos_total} />
                <NumberGridTargetInfo label='Efectivo Bs.' data={data?.efectivo_total} borderBotton={false} />
                {/* <EmptyGridTargetInfo label='.' data='' borderBotton={false} /> */}
            </NumberCalculatorsTargetInfo>
            <NumberCalculatorsTargetInfo>
                <NumberGridTargetInfo label='Garantías Bs.' data={data?.garantias_total} />
                <NumberGridTargetInfo label='Garantías Bs Transf.' data={data?.garantias_total_transferencia} />
                
                <NumberGridTargetInfo label='Gar. ingresos Bs.' data={data?.garantias_ingreso} />
                <NumberGridTargetInfo label='Gar. egresos Bs.' data={data?.garantias_egreso} />
                {/* <NumberGridTargetInfo label='Efvo. sobrante Bs.' data={data?.tipo === 'sobrante' ? data?.faltante_sobrante_calculado_string : '0,00'} /> */}
                <NumberGridTargetInfo label='Efvo. faltante Bs.' data={data?.tipo === 'faltante' ? data?.faltante_sobrante_calculado_string : '0,00'} />
                {/* <NumberGridTargetInfo label='Efvo. entregado Bs.' data={data?.efectivo_entregado} /> */}
                {/* <NumberGridTargetInfo label='Efvo. neto Bs.' data={data?.efectivo_total_neto} borderBotton={false} /> */}
                <NumberGridTargetInfo label='' data={''} borderBotton={false} />
            </NumberCalculatorsTargetInfo>
        </MainTargetInfo>
    )
}

export default CardInfo